<template>
  <div class="chat_box">
    <div class="prof seller">
      <div class="inner">
        <img
          src="@/assets/front/images/v2/profiles/img_perce_prof_w.png"
          alt=""
        />
      </div>
    </div>
    <div class="chat_con perce_chat_con">
      <div class="chat_txt">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          매장에서 휴대폰 개통신청서를 열람하였습니다.<br />휴대폰 개통 완료 시
          반드시 확인해주세요!
        </div>
        <div class="chat_msg system">
          휴대폰 개통 후 늦어도 1주일 이내에 수신 받은 개통내역 안내문자 또는
          고객센터 앱을 통하여 아래의 항목이 견적내역과 일치하는지 반드시
          확인하세요.<br />1. 개통기기<br />2. 할부원금<br />3. 개통요금제<br />4.
          공시지원 or 선택약정
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatRoomMobileApplyOpen',
  description: '휴대폰 개통신청서 열람 시스템 메세지',
  props: {
    isCustomer: Boolean,
  },
  methods: {},
};
</script>

<style></style>
